/* eslint-disable filenames/no-index */
// Meant to be performed as `node -r log-process-errors/build/register`
// or `import 'log-process-errors/build/register'`.
import logProcessErrors from '../src/main.js'

logProcessErrors()
/* eslint-enable filenames/no-index */
